import { isValid, parse } from 'date-fns';

import { formatDate } from 'lib/helpers/dateUtils';

export const getIsOptionActive = ({ option, label, text, customButton, timezone = null }) => {
  const selectedValue = text ?? customButton?.props?.value;
  const selectedDate = selectedValue ? new Date(selectedValue) : null;
  const selectedTimeValue =
    selectedDate && isValid(selectedDate) ? formatDate(selectedDate, timezone, 'HH:mm') : null;

  let labelTimeValue = null;
  if (typeof label === 'string') {
    const trimmed = label.trim();
    let parsedLabel = parse(trimmed, 'h:mm a', new Date());
    if (!isValid(parsedLabel)) {
      parsedLabel = parse(trimmed, 'h:mma', new Date());
    }
    if (isValid(parsedLabel)) {
      labelTimeValue = formatDate(parsedLabel, timezone, 'HH:mm');
    }
  }

  const isSameTime =
    Boolean(selectedTimeValue) &&
    ((option?.value && option.value === selectedTimeValue) ||
      (labelTimeValue && labelTimeValue === selectedTimeValue));

  return label === text || option?.value === selectedValue || isSameTime;
};
